import { Component, computed, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceModel, MeterRole, effectiveMeterRole } from '@core/models';
import { InsightsTopologicalContentComponent } from '@root/custom-components/sections/insights-topological-content/insights-topological-content.component';

@Component({
  selector: 'xemex-device-telemetry-tab',
  imports: [
    MatButtonModule,
    MatProgressSpinnerModule,
    TranslateModule,
    InsightsTopologicalContentComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './device-telemetry-tab.component.html',
})
export class DeviceTelemetryTabComponent {
  deviceDetail = input<DeviceModel>();
  partnerDefaultMeterRole = input<MeterRole>();
  isPerformingReadout = input<boolean>(false);
  telemetryNotShared = input(false);
  performReadout = output();

  meterRole = computed(() =>
    effectiveMeterRole(this.deviceDetail()?.meterRole, this.partnerDefaultMeterRole()),
  );

  performOnDemandReadout() {
    this.performReadout.emit();
  }
}
